import Vue from 'vue'

import {
  ROUTING_SHOW_OVERLAY,
  ROUTING_TRANSITION_MAIN,
  ROUTING_TRANSITION_OVERLAY,
  MUTATE_SET_SHOW_OVERLAY,
  MUTATE_SET_TRANSITION_MAIN,
  MUTATE_SET_TRANSITION_OVERLAY,
  ACTION_SET_TRANSITION_MAIN_ASYNC,
  APP_PREV_ROUTE,
  MUTATE_POP_NAV_HISTORY,
  MUTATE_PUSH_NAV_HISTORY,
  MUTATE_ROUTE_QUERY,
  ROUTING_QUERY,
} from './types';

const state = {
  RouteQuery: null,
  ShowOverlay: false,
  TransitionMain: 'smd-transition-panes',
  TransitionOverlay: 'smd-transition-overlay',
  NavHistory: [],
};

const getters = {
  [ROUTING_QUERY]: state => {
    return state.RouteQuery || {};
  },
  [ROUTING_SHOW_OVERLAY]: state => {
    return state.ShowOverlay
  },
  [ROUTING_TRANSITION_MAIN]: state => {
    return state.TransitionMain
  },
  [ROUTING_TRANSITION_OVERLAY]: state => {
    return state.TransitionOverlay
  },
  [APP_PREV_ROUTE]: state => {
    const historyStack = state.NavHistory;
    const len = historyStack.length;
    return len > 0 ? historyStack[len - 1] : null;
  }
};

const mutations = {
  [MUTATE_ROUTE_QUERY]: (state, payload) => {
    state.RouteQuery = payload;
  },
  [MUTATE_SET_SHOW_OVERLAY]: (state, payload) => {
    state.ShowOverlay = payload;
  },
  [MUTATE_SET_TRANSITION_MAIN]: (state, payload) => {
    state.TransitionMain = payload;
  },
  [MUTATE_SET_TRANSITION_OVERLAY]: (state, payload) => {
    state.TransitionOverlay = payload;
  },
  [MUTATE_POP_NAV_HISTORY]: (state) => {
    const len = state.NavHistory.length;
    if (len > 0) {
      Vue.delete(state.NavHistory, len - 1);
    }
  },
  [MUTATE_PUSH_NAV_HISTORY]: (state, payload) => {
    Vue.set(state.NavHistory, state.NavHistory.length, payload);
  },
};

const actions = {
  [ACTION_SET_TRANSITION_MAIN_ASYNC]: ({commit}, payload) => {
    setTimeout(() => {
      commit(MUTATE_SET_TRANSITION_MAIN, payload.value);
      commit(MUTATE_SET_SHOW_OVERLAY, false);
    }, payload.duration);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
}